export default __webpack_public_path__ + "static/media/billing-gray-no-img.18a54fce.svg";